export const topics = [
  { id: 1, name: '娱乐圈大瓜', heat: '98.6万', trending: true, color: 'primary' },
  { id: 2, name: '科技圈内幕', heat: '87.3万', trending: true, color: 'accent' },
  { id: 3, name: '社会热点追踪', heat: '76.2万', trending: false, color: 'secondary' },
  { id: 4, name: '财经猛料', heat: '65.8万', trending: true, color: 'accent' },
  { id: 5, name: '体育圈秘闻', heat: '54.1万', trending: false, color: 'primary' },
  { id: 6, name: '国际时事深挖', heat: '48.9万', trending: false, color: 'secondary' },
  { id: 7, name: '网红翻车实录', heat: '43.5万', trending: true, color: 'primary' },
  { id: 8, name: '职场黑幕曝光', heat: '37.2万', trending: false, color: 'accent' },
  { id: 9, name: '直播圈猛料', heat: '31.8万', trending: true, color: 'secondary' },
];

export const rankings = [
  { rank: 1, title: '某顶流艺人深夜密会神秘女子，酒店同框照流出', heat: '2.3亿', change: 'up', tag: '独家' },
  { rank: 2, title: '知名企业高管群聊记录外泄，涉及行业内幕交易', heat: '1.8亿', change: 'up', tag: '猛料' },
  { rank: 3, title: '热门综艺节目录制现场冲突，导演组与嘉宾爆发争执', heat: '1.5亿', change: 'down', tag: '实时' },
  { rank: 4, title: '某电商平台数据造假被内部员工举报，证据链完整', heat: '1.2亿', change: 'up', tag: '独家' },
  { rank: 5, title: '知名品牌代言人合同纠纷升级，双方各执一词', heat: '9.8千万', change: 'up', tag: '追踪' },
  { rank: 6, title: '某地官员违规操作被网络爆料，相关部门已介入调查', heat: '8.6千万', change: 'new', tag: '突发' },
];

export const indexCollections = [
  { id: 1, title: '娱乐圈年度十大爆料盘点', summary: '那些震动娱乐圈的重磅消息，一文回顾年度最热瓜料', imageSeq: 'collection-01' },
  { id: 2, title: '互联网大厂内幕系列', summary: '独家揭秘科技巨头背后的真实故事与职场生态', imageSeq: 'collection-02' },
  { id: 3, title: '社会热点深度追踪', summary: '持续关注重大社会事件的最新进展与多方声音', imageSeq: 'collection-03' },
  { id: 4, title: '明星塌房全记录', summary: '从顶流到翻车，完整还原明星争议事件始末', imageSeq: 'collection-04' },
  { id: 5, title: '财经圈劲爆内幕', summary: '资本运作、企业并购背后的不为人知的博弈与暗流', imageSeq: 'collection-05' },
  { id: 6, title: '直播带货乱象调查', summary: '揭秘直播电商行业中的虚假宣传与消费陷阱', imageSeq: 'collection-06' },
  { id: 7, title: '国际时事独家解读', summary: '全球热点事件的深度分析与独家信源披露', imageSeq: 'collection-07' },
  { id: 8, title: '体育圈秘闻档案', summary: '赛场之外的转会内幕、合同纠纷与球员私生活', imageSeq: 'collection-08' },
  { id: 9, title: '网红生态全透视', summary: '从爆红到崩塌，网红经济背后的真实生态圈', imageSeq: 'collection-09' },
];

export const mediaItems = [
  { id: 1, title: '独家：某知名艺人工作室内部录音曝光', duration: '12:38', views: '856万', imageSeq: 'media-01' },
  { id: 2, title: '暗访：代工厂连夜赶制名牌仿品的完整链条', duration: '18:25', views: '623万', imageSeq: 'media-02' },
  { id: 3, title: '揭秘：某互联网大厂裁员背后的资本博弈', duration: '09:14', views: '489万', imageSeq: 'media-03' },
  { id: 4, title: '独家跟拍：顶流网红私下的真实生活状态', duration: '15:02', views: '742万', imageSeq: 'media-04' },
];

export const comments = [
  { id: 1, username: '吃瓜不嫌事大', avatar: '🍉', content: '天哪这个爆料太劲爆了！我直接原地炸裂，转发给所有朋友看了，大家都在疯狂讨论。这瓜保熟！', time: '2小时前', likes: 3281 },
  { id: 2, username: '真相挖掘机', avatar: '🔍', content: '作为业内人士说一句，这条爆料的细节基本属实，但时间线上有些出入。等我有空写个详细分析对比。先蹲一个后续。', time: '5小时前', likes: 2156 },
  { id: 3, username: '深夜冲浪选手', avatar: '🌙', content: '连续追了三天的瓜了，每天都有新进展，这剧情感比电视剧还精彩。爆料专区的更新速度真的没话说，永远第一时间蹲到最新料。', time: '8小时前', likes: 1893 },
];

export const updates = [
  { id: 1, time: '10分钟前', title: '【突发】某知名综艺节目总导演被曝收受选手贿赂，节目组发声明否认', urgent: true },
  { id: 2, time: '32分钟前', title: '独家获取某品牌代言纠纷内部文件，合同细节首次公开', urgent: false },
  { id: 3, time: '1小时前', title: '网红主播涉虚假宣传被市场监管部门立案调查，直播账号已停更', urgent: true },
  { id: 4, time: '2小时前', title: '某地房地产项目资金链断裂内幕被内部员工群发邮件曝光', urgent: false },
  { id: 5, time: '3小时前', title: '知名歌手疑似抄袭国外小众歌曲，网友扒出音轨对比证据', urgent: false },
  { id: 6, time: '4小时前', title: '某连锁餐饮品牌后厨卫生问题遭前员工实名举报，多段视频流出', urgent: true },
  { id: 7, time: '5小时前', title: '科技巨头高管内部会议录音泄露，涉及重大战略调整计划', urgent: false },
  { id: 8, time: '6小时前', title: '娱乐圈知名经纪人与艺人解约内幕，分手费数额惊人', urgent: false },
];

export const faqItems = [
  {
    id: 1,
    question: '爆料专区的信息来源是否可靠？',
    answer: '我们的信息来源于多渠道交叉验证，包括一线知情人士投稿、公开信息深度挖掘、行业内部信源等。每条爆料发布前均经过至少两轮事实核查，确保信息准确度。对于未经充分证实的内容，我们会明确标注"待核实"标签。',
  },
  {
    id: 2,
    question: '如何向爆料专区投稿或提供线索？',
    answer: '你可以在页面底部的"联系我们"区域找到投稿入口。我们接受文字、图片、音频、视频等多种形式的线索材料。所有投稿均严格保护投稿人隐私，你可以选择匿名提交。一经采用，我们会根据线索价值给予相应奖励。',
  },
  {
    id: 3,
    question: '爆料专区的内容多久更新一次？',
    answer: '我们的编辑团队实行全天候轮班制，确保24小时不间断更新。重大突发爆料最快可在事件发生后15分钟内完成信息采集与发布。常规内容每30分钟进行一次全面刷新，保证你永远能看到最新最热的爆料内容。',
  },
  {
    id: 4,
    question: '爆料专区与其他新闻资讯平台有什么不同？',
    answer: '与传统新闻平台不同，爆料专区专注于"第一手内幕"和"独家视角"。我们不满足于转载通稿，而是深入挖掘事件背后的真实故事。同时，我们保持开放的态度，欢迎读者参与讨论和爆料，形成良性的信息共享生态。',
  },
];

export const cards = [
  { id: 1, title: '某影视公司财务造假被内部审计揭发，涉案金额超十亿', category: '财经猛料', summary: '一份流出的内部审计报告显示，某知名影视制作公司涉嫌通过虚增成本和关联交易进行财务造假。该报告详细列出了过去三年间的异常资金流动，涉及多家壳公司和境外账户。消息一出，该公司股价应声下跌超过30%，引发监管部门关注。', imageSeq: 'card-01', time: '3小时前', reads: '128万' },
  { id: 2, title: '顶流爱豆隐婚生子？知情人透露孩子已满三岁', category: '娱乐圈大瓜', summary: '某顶流男团成员被知情人士爆料已秘密结婚并育有一子。据称其配偶为圈外人士，两人于三年前在海外注册结婚。消息人士还提供了疑似家庭出游的照片作为佐证。该艺人经纪公司目前尚未对此事做出任何回应。', imageSeq: 'card-02', time: '6小时前', reads: '356万' },
  { id: 3, title: '某外卖平台算法压榨骑手被曝光，内部沟通记录触目惊心', category: '社会热点追踪', summary: '一份据称来自某头部外卖平台的内部沟通记录被曝光，其中明确提到通过算法不断压缩骑手配送时间以提升平台利润。记录显示管理层清楚这种做法会增加交通事故风险，但仍决定推行。', imageSeq: 'card-03', time: '9小时前', reads: '215万' },
  { id: 4, title: '国际知名投资机构做空报告曝光，目标指向中概股巨头', category: '国际时事深挖', summary: '一份标注为"机密"的做空研究报告被泄露，详细列出了某中概股龙头企业存在的财务问题和合规风险。报告长达87页，包含大量财务数据分析和实地调查证据。该机构计划在未来两周内正式发布做空声明。', imageSeq: 'card-04', time: '12小时前', reads: '189万' },
  { id: 5, title: '某选秀节目排名造假证据曝光，投票数据被篡改', category: '娱乐圈大瓜', summary: '一位自称参与过某热门选秀节目幕后工作的匿名人士提供了大量截图和聊天记录，显示节目组在总决赛前人为调整了选手排名。证据包括被修改的投票数据库截图和导演组的内部讨论消息。', imageSeq: 'card-05', time: '15小时前', reads: '432万' },
  { id: 6, title: '知名连锁健身房跑路前内部预警邮件流出', category: '职场黑幕曝光', summary: '某全国连锁健身品牌在宣布破产前一周，其区域经理向总部发送的预警邮件被曝光。邮件中详细描述了公司面临的资金链断裂风险和建议的应对方案，但总部选择无视并继续大力促销年卡。', imageSeq: 'card-06', time: '18小时前', reads: '167万' },
  { id: 7, title: '某地高考阅卷存在违规操作，退休教师实名举报', category: '社会热点追踪', summary: '一位曾参与高考阅卷工作的退休教师实名向媒体举报，称其在阅卷过程中发现存在评分标准被人为调整的情况。举报材料包含详细的阅卷流程记录和异常评分数据对比。当地教育部门表示已成立专项调查组。', imageSeq: 'card-07', time: '21小时前', reads: '278万' },
];

export const carouselItems = [
  { id: 1, title: '深度专题：娱乐圈资本局 — 谁在操控你看到的明星热搜？', summary: '从资本视角拆解娱乐圈热搜产业链，揭秘背后推手与利益分配机制。本专题持续追踪热搜买卖、水军运营、数据造假等灰色地带，还原一个真实的娱乐圈舆论场。', imageSeq: 'carousel-01', tag: '深度专题', reads: '1,286万' },
  { id: 2, title: '独家策划：互联网大厂离职潮背后的真相', summary: '2026年上半年，各大互联网公司迎来史无前例的离职潮。是行业寒冬还是人才洗牌？我们采访了23位来自不同大厂的离职员工，还原他们离开的真实原因。', imageSeq: 'carousel-02', tag: '独家策划', reads: '968万' },
  { id: 3, title: '系列追踪：直播电商乱象调查完整报告', summary: '历时三个月，深入全国六个直播基地，暗访38位从业者，从选品、话术、数据、售后四个维度全面起底直播电商行业中不为人知的潜规则与欺诈手段。', imageSeq: 'carousel-03', tag: '系列追踪', reads: '1,542万' },
  { id: 4, title: '重磅揭秘：某地产巨头海外资产转移路径全曝光', summary: '通过多国公开注册资料和内部知情人士提供的信息，完整还原某头部地产集团通过离岸架构转移资产的复杂路径。涉及八个国家和地区，数百家壳公司，资金规模令人震惊。', imageSeq: 'carousel-04', tag: '重磅揭秘', reads: '2,089万' },
];

export const appInfo = {
  title: '随时随地，爆料不错过',
  description: '下载爆料专区移动客户端，第一时间接收劲爆推送。支持 iOS 与 Android 双平台，开启通知权限即可在重大爆料发布时即时获知。离线阅读、夜间模式、个性化订阅等特色功能让你的吃瓜体验更加畅快。',
  features: ['实时推送', '离线阅读', '夜间模式', '个性订阅'],
};

export const aboutInfo = {
  title: '关于爆料专区',
  description: '爆料专区成立于2023年，是国内领先的独家爆料与热点资讯聚合平台。我们致力于打破信息壁垒，为读者提供第一手内幕消息和深度解读。团队成员来自主流媒体、调查机构和互联网行业，拥有丰富的信息挖掘和事实核查经验。',
  stats: [
    { label: '日均爆料', value: '200+' },
    { label: '独家内容占比', value: '65%' },
    { label: '月活跃读者', value: '8,600万' },
    { label: '合作信源', value: '500+' },
  ],
};

export const contactInfo = {
  title: '联系我们 / 爆料投稿',
  description: '如果你掌握独家内幕、行业猛料或社会黑幕线索，欢迎通过以下方式与我们取得联系。我们郑重承诺对所有爆料人信息严格保密，并为重大独家线索提供丰厚奖励。请确保所提供信息真实可靠，虚假信息将不予受理。',
  email: 'tips@baoliaozone.com',
  phone: '400-888-6688',
  tips: [
    '来信请尽可能提供详细的证据材料',
    '匿名投稿请使用加密通讯方式',
    '重大独家线索奖励 ¥5,000 - ¥500,000',
  ],
};

export const features = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '独家信源，双重核验',
    description: '每条爆料均来自一线知情人士或深度调查团队，发布前经过至少两轮交叉验证。我们坚持"宁缺毋滥"原则，确保每一条推送都经得起推敲。',
  },
  {
    id: 2,
    icon: 'ri-timer-flash-line',
    title: '全天候更新，快人一步',
    description: '编辑团队7×24小时不间断值守，重大突发爆料最快15分钟上线。智能推送系统根据你的兴趣偏好精准分发，让你永远走在信息链的最前端。',
  },
  {
    id: 3,
    icon: 'ri-user-voice-line',
    title: '保护爆料人，安全至上',
    description: '采用多层加密技术保护爆料人身份信息，支持匿名投稿与加密通讯。自成立以来，从未发生过一起爆料人信息泄露事件，这是我们最珍视的信誉。',
  },
];

export const navLinks = [
  { label: '读者热议', href: '#comments' },
  { label: '实时快讯', href: '#updates' },
  { label: '独家视频', href: '#media' },
  { label: '深度专题', href: '#carousel' },
  { label: '平台优势', href: '#features' },
];